import React from 'react';
import { Text, IconError16, Box } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';
type ValidationErrorMessageProps = {
  message: string;
};
export const ValidationErrorMessage = ({
  message
}: ValidationErrorMessageProps) => {
  return <Box className={styles.errorWrapper} role="alert">
      <IconError16 className="errorIcon" type="icon" title="error" color="red-40" />
      <Text family="regular" height="standard" scale="4" color="red-40" ml="0.5rem">
        {message}
      </Text>
    </Box>;
};